<template>
  <div class="multi-text-editor">
    <div class="editor-header">
      <span class="editor-title">{{ title }}</span>
      <div class="editor-actions">
        <el-button 
          type="primary" 
          size="mini" 
          icon="el-icon-plus"
          @click="addItem"
        >
          添加{{ itemLabel }}
        </el-button>
      </div>
    </div>

    <!-- 编辑模式 -->
    <div class="edit-mode">
      <div 
        v-for="(item, index) in localValue" 
        :key="index" 
        class="edit-item"
      >
        <div class="item-header">
          <span class="item-label">{{ itemLabel }} {{ index + 1 }}</span>
          <el-button 
            type="danger" 
            size="mini" 
            icon="el-icon-close"
            @click="removeItem(index)"
            circle
          ></el-button>
        </div>
        <RichTextEditor 
          :key="`key_${index}`"
          :key-word="index"
          :params="localValue"
          v-model="localValue[index]"
          @input="handleItemChange"
        />
      </div>
      <el-button 
        type="primary" 
        size="mini" 
        icon="el-icon-plus"
        @click="addItem"
        class="add-item-btn"
        v-if="localValue.length === 0"
      >
        添加{{ itemLabel }}
      </el-button>
    </div>
  </div>
</template>

<script>
import RichTextEditor from './richText.vue';

export default {
  name: 'MultiTextEditor',
  components: {
    RichTextEditor,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '多文本编辑'
    },
    itemLabel: {
      type: String,
      default: '项目'
    }
  },
  data() {
    return {
      localValue: []
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = [...(newVal || [])];
        // 确保至少有一个项目
        if (this.localValue.length === 0) {
          this.localValue.push('');
        }
      },
      immediate: true
    }
  },
  methods: {
    addItem() {
      this.localValue.push('');
      this.emitChange();
    },
    removeItem(index) {
      this.localValue.splice(index, 1);
      // 如果删除后没有项目了，添加一个空项目
      if (this.localValue.length === 0) {
        this.localValue.push('');
      }
      this.emitChange();
    },
    handleItemChange() {
      this.emitChange();
    },
    emitChange() {
      // 过滤掉空的项目，但保留至少一个项目用于编辑
      const filteredData =[... this.localValue];
      this.$emit('input', filteredData);
      this.$emit('change', filteredData);
    }
  }
};
</script>

<style scoped lang="scss">
.multi-text-editor {
  width: 100%;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.editor-title {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}

.editor-actions {
  display: flex;
  gap: 8px;
}

// 编辑模式样式
.edit-mode {
  .edit-item {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fafafa;
    
    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      
      .item-label {
        font-weight: 500;
        color: #606266;
      }
    }
  }
  
  .add-item-btn {
    margin-top: 10px;
  }
}
</style> 